// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"328e7dc8","787":"70079b53"}[chunkId] + ".chunk.js";
};